const registerShopES = {
	step: "Paso {{step}} de 3",

	step1: {
		title: "Crear cuenta de administrador",
		subtitle: "Elige la contraseña de tu cuenta de dueño y te llevamos directo a tu calendario.",
		invitedTo: "Configurando",
		email: "Correo electrónico",
		sectionAbout: "Sobre ti",
		sectionSecurity: "Seguridad",
		sectionBusiness: "Tu negocio",
		category: "Categoría",
		subCategory: "Subcategoría",
		categoryPlaceholder: "Tipo de negocio",
		subCategoryPlaceholder: "Subcategoría",
		firstName: "Nombre",
		lastName: "Apellido",
		phone: "Número de teléfono",
		password: "Contraseña",
		confirmPassword: "Confirmar contraseña",
		upload:"Subir",
		remember: "Recordarme",
		register: "Registrar",
		registering: "Registrando...",
		referralCode: "Código de referido",
		ownerTakesBookings: {
			label: "¿Atiendes citas personalmente?",
			yes: "Sí, atiendo",
			yesHint: "Tendrás tu propio calendario para que los clientes reserven contigo.",
			no: "No, mi personal atiende",
			noHint: "Tú administras el negocio. Tu personal atiende las citas.",
			noteYes: "Puedes agregar personal y sus calendarios cuando quieras.",
			noteNo: "A continuación invitarás a tu primer miembro del personal — tendrá su propio acceso y calendario, y tu plan sigue cubriendo el primero.",
		},
		acceptTerms: "Acepto los",
		termsLink: "Términos y Condiciones",
	},

	step2: {
		title: "Registra tu negocio",
		shopName: "Nombre del negocio",
		address: "Dirección",
		city: "Ciudad",
		country: "País",
		postalCode: "Código postal",
		description: "Descripción",
		category: "Tipo de negocio",
		openingHours: "Horario de apertura",
		closed: "Cerrado",
		socials: "Redes sociales (opcional)",
		instagram: "URL de Instagram",
		facebook: "URL de Facebook",
		tiktok: "URL de TikTok",
		website: "Sitio web",
		next: "Siguiente paso",
		registering: "Registrando...",
	},

	step3: {
		title: "Servicios y fotos",
		description: "Agrega al menos un servicio para finalizar el registro.",
		photos: "Fotos del portafolio",
		upload: "Subir fotos",
		finish: "Finalizar registro",
		registering: "Registrando...",
	},

	errors: {
		fillRequired: "¡Casi listo! Completa los campos obligatorios para continuar.",
		passwordMatch: "Las contraseñas no coinciden. Revísalas e inténtalo de nuevo.",
		uploadImages: "Agrega al menos una foto para finalizar tu registro.",
		invalidInvite: "Este enlace de invitación ya no es válido o expiró. Solicita uno nuevo.",
		mustAcceptTerms: "Necesitamos que aceptes los Términos y Condiciones para continuar.",
	},

	success: {
		adminCreated: "¡Listo! Tu cuenta está creada — ahora registremos tu negocio.",
		returning: "¡Qué bueno verte de nuevo! Sigamos registrando tu negocio.",
	},

	days: {
		Monday: "Lunes",
		Tuesday: "Martes",
		Wednesday: "Miércoles",
		Thursday: "Jueves",
		Friday: "Viernes",
		Saturday: "Sábado",
		Sunday: "Domingo",
	},
};

export default registerShopES;
